import a from "react";
import { getIconColor as i } from "./iconfont.es5470.js";
import x from "./iconfont.es5471.js";
const m = {
  display: "block"
}, g = ({ size: e = 16, useVw: n, useRem: o, color: c, withColor: l, removeClassName: t, disableSSR: d, style: r, ...h }) => {
  const p = r ? { ...m, ...r } : m;
  return /* @__PURE__ */ a.createElement(x, { disableSSR: d }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-yongxuheyue", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (o ? "rem" : "px"), height: n ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (o ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: p, fill: "none", ...h }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: t ? "" : "32px-æ°¸ç»­åçº¦"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: t ? "" : "normal",
        fill: l ? i(c, 0, "#262933") : "#262933",
        datafollowfill: l ? i(c, 0, "#262933") : "#262933"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M4.6 7.56a3.9 3.9 0 0 1 3.9-3.9h13.18a3.9 3.9 0 0 1 3.9 3.9v7.395a2.104 2.104 0 0 1-2.103 2.103h-4.7a.304.304 0 0 0-.304.304v8.59l2.152-2.096a2.104 2.104 0 0 1 2.96.023l2.015 2.026V20.42a.9.9 0 1 1 1.8 0v6.208c0 1.34-1.622 2.009-2.566 1.059l-2.526-2.539a.304.304 0 0 0-.427-.003l-2.659 2.59c-.951.927-2.55.253-2.55-1.076v-9.297c0-1.162.942-2.103 2.104-2.103h4.7a.304.304 0 0 0 .304-.304V7.56a2.1 2.1 0 0 0-2.1-2.1H8.5a2.1 2.1 0 0 0-2.1 2.1v15a2.1 2.1 0 0 0 2.1 2.1h3.596a.9.9 0 1 1 0 1.8H8.5a3.9 3.9 0 0 1-3.9-3.9v-15Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M9.08 10.005a.9.9 0 0 1 .9-.9h9.427a.9.9 0 1 1 0 1.8H9.98a.9.9 0 0 1-.9-.9Zm.9 3.741a.9.9 0 1 0 0 1.8h3.18a.9.9 0 1 0 0-1.8H9.98Z"
        }
      )
    )
  )));
}, u = g;
export {
  u as default
};
